import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faChevronLeft } from '@fortawesome/pro-solid-svg-icons/faChevronLeft';
import { faChevronRight } from '@fortawesome/pro-solid-svg-icons/faChevronRight';

import React from 'react';
import { createColumnDefinitionBuilder } from 'ui-components/components/react-table-wrapper/create-column-definition-builder';
import { Button } from 'ui-components/components/button';
import { CellPropTypes } from '../../../../../../prop-types/react-table';
import { CsvColumnValue } from '../../csv-column-value/csv-column-value';
import { useImportContext } from '../../import-context';
import styles from './styles.module.less';
import classnames from 'clsx';
import { FormattedMessage } from 'react-intl';
import { messages } from './messages';

const PreviewDataCell = ({ row }) => {
  const { getMappedCsvColumn } = useImportContext();

  const csvColumn = getMappedCsvColumn(row.original) || {};

  return (
    <div className={styles['preview-data-cell']}>
      <CsvColumnValue csvColumn={csvColumn} />
    </div>
  );
};

PreviewDataCell.propTypes = CellPropTypes;

const PreviewDataHeader = () => {
  const { getRowNumbers, getNextDataRow, getPreviousDataRow, getCurrentRowNumber } = useImportContext();

  const rowNum = getCurrentRowNumber();
  const totalRows = getRowNumbers();

  return (
    <div className={styles.content}>
      <Button className={styles['select-data']} onClick={getPreviousDataRow} theme='unstyled'>
        <FontAwesomeIcon className={classnames(styles['chevron-icon'], { [styles.inactive]: rowNum === 1 })} icon={faChevronLeft} />
      </Button>
      <span className={styles['header-title']}>
        <FormattedMessage {...messages.dataPreview} values={{ current: rowNum, all: totalRows }} />
      </span>
      <Button className={styles['select-data']} onClick={getNextDataRow} theme='unstyled'>
        <FontAwesomeIcon
          className={classnames(styles['chevron-icon'], { [styles.inactive]: rowNum === totalRows })}
          icon={faChevronRight}
        />
      </Button>
    </div>
  );
};

export const createPreviewDataColumnDefinition = createColumnDefinitionBuilder({
  accessor: 'previewData',
  Header: <PreviewDataHeader />,
  Cell: PreviewDataCell,
  width: 1,
});
